export enum ItemCondition {
  Good = 0,
  VeryGood,
  BrandNew,
}
